"use client";

import { useState } from "react";

import { Button } from "#ui/button";
import { Icon } from "#ui/icon";

import type { NewsCriteriaInput } from "./criteria-builder";
import { NewsDetail } from "./news-detail";
import { type NewsItemClickEvent, NewsList } from "./news-list";
import { useStockLinkClick } from "./use-stock-link-click";

export function MarketNews({
  criteria,
  ariaLevel,
}: {
  criteria?: NewsCriteriaInput;
  ariaLevel?: "2" | "3" | "4" | "5" | "6";
}) {
  const [selectedNewsId, setSelectedNewsId] = useState<string | null>(null);
  const stockLinkClick = useStockLinkClick();

  if (selectedNewsId) {
    return (
      <div className="mx-auto block max-w-800px space-y-20px">
        <Button
          onClick={() => {
            setSelectedNewsId(null);
          }}
          size="sm"
          variant="outline"
          palette="neutral"
        >
          <Icon name="ms-navigate-prev" />
          <span>Back To List</span>
        </Button>
        <NewsDetail
          ariaLevel={ariaLevel}
          identifier={selectedNewsId}
          symbolLinkClick={stockLinkClick}
        />
      </div>
    );
  }

  return (
    <NewsList
      onNewsClick={(event: NewsItemClickEvent) => {
        setSelectedNewsId(event.detail[0].identifier);
      }}
      criteria={criteria}
    />
  );
}
